export default __webpack_public_path__ + "static/media/bul_logo.330c326e.png";